import styled from 'styled-components';

import { colors } from '../../../utils/utils';

const VersionInfo = styled.div`
    display: flex;

    justify-content: flex-end;

    padding: 0 5px;

    color: ${colors.gray.jumbo};
    font-size: 11px;
    margin-bottom: 4px;
`;

export default VersionInfo;
